import { statusVariants } from '@routable/gross-ds';
import { TagType } from 'constants/ui';
export const tagTypeToStatusVariant = {
    [TagType.DEFAULT]: statusVariants.default,
    [TagType.SUCCESS]: statusVariants.success,
    [TagType.ERROR]: statusVariants.error,
};
